import React, { Component } from 'react'
import {
    Tooltip
} from 'reactstrap';
import { Link } from 'react-router-dom';

class ActionsRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            TooltipArchive: false,
            TooltipView: false
        };
    }
    toggleTooltipArchive() {
        this.setState({
            TooltipArchive: !this.state.TooltipArchive
        });
    }
    toggleTooltipView() {
        this.setState({
            TooltipView: !this.state.TooltipView
        });
    }
    actionArchive(){
        this.props.casoToArchive(this.props.casoId, true)
    }
    actionActivate(){
        this.props.casoToArchive(this.props.casoId, false)
    }
    actionRemove(){
        this.props.removeCaso(this.props.casoId)
    }
    render(){
        return(
            <div className="btn-group btn-group-sm actions-row" role="group">
                {!this.props.isAdmin ? this.props.archived === 0 ?
                <button
                    id={"TooltipArchive_" + this.props.casoId}
                    type="button"
                    className="btn btn-sm btn-outline-warning"
                    onClick={this.actionArchive.bind(this)}
                >
                    <i className="fa fa-archive" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipArchive}
                        target={"TooltipArchive_" + this.props.casoId}
                        toggle={this.toggleTooltipArchive.bind(this)}
                    >
                        Archivar caso
                    </Tooltip>
                </button>
                :
                <button
                    id={"TooltipArchive_" + this.props.casoId}
                    type="button"
                    className="btn btn-sm btn-outline-warning"
                    onClick={this.actionActivate.bind(this)}
                >
                    <i className="fa fa-folder-open" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipArchive}
                        target={"TooltipArchive_" + this.props.casoId}
                        toggle={this.toggleTooltipArchive.bind(this)}
                    >
                        Activar caso
                    </Tooltip>
                </button>
                    :
                <button
                    id={"TooltipArchive_" + this.props.casoId}
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={this.actionRemove.bind(this)}
                >
                    <i className="fa fa-remove" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipArchive}
                        target={"TooltipArchive_" + this.props.casoId}
                        toggle={this.toggleTooltipArchive.bind(this)}
                    >
                        Borrar caso
                    </Tooltip>
                </button>
                }
                <Link
                    className="panel-block"
                    to={"/casos/" + this.props.casoId}>
                    <button id={"TooltipView" + this.props.casoId}
                            type="button"
                            className="btn btn-sm btn-outline-success">
                        <i className="fa fa-eye" />
                    </button>
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipView}
                        target={"TooltipView" + this.props.casoId}
                        toggle={this.toggleTooltipView.bind(this)}
                    >
                        Ver caso
                    </Tooltip>
                </Link>
            </div>
        )
    }
}
export default ActionsRow


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/ActionsRow.jsx